<template>
  <div class="container">
    <ul class="purchase-path">
      <a
        class="path-status"
        :href="packagePath"
      >
        <span class="path-status-number">1</span>
        <span class="nav-package-text">{{ $t('h4h.yourPackage') }}</span>
      </a>
      <a
        class="path-status path-status-number-middle"
        :class="windowPath !== checkoutPath ? 'in-progress' : ''"
        :href="windowPath === checkoutPath ? hotelPath : null"
      >
        <span
          :class="windowPath !== checkoutPath ?
            'path-status-number-active': 'path-status-number'"
        >2</span>
        <span :class="windowPath === checkoutPath ? 'nav-package-text' : ''">
          {{ $t('h4h.chooseAccomodation') }}
        </span>
      </a>
      <a
        class="path-status checkout"
        :class="windowPath === checkoutPath ? 'in-progress' : ''"
        :href="windowPath !== checkoutPath ? checkoutPath : null"
      >
        <span
          :class="windowPath === checkoutPath ?
            'path-status-number-active': 'path-status-number'"
        >3</span>
        <span :class="windowPath !== checkoutPath ? 'nav-package-text' : ''">
          {{ $t('h4h.checkoutStep') }}
        </span>
      </a>
    </ul>
  </div>
</template>

<script>
/* global locale */

import Api from '../../cart/cart_api'

export default {
  data() {
    return {
      packageId: null,
      orderItemId: null,
      checkoutPath: '/cart/checkout'
    }
  },

  computed: {
    packagePath() {
      return `/${locale}/packages/${this.packageId}/path`
    },
    hotelPath() {
      return `/${locale}/cart/items/${this.orderItemId}/hotels`
    },
    windowPath() {
      return window.location.pathname
    }
  },

  created() {
    this.getOrder()
  },

  methods: {
    async getOrder() {
      let order = await Api.getOrder()
      let last = order.items.length - 1

      this.packageId = order.items[last].package_id
      this.orderItemId = order.items[last].id
    }
  }
}
</script>
